export default __webpack_public_path__ + "static/media/ManageMultiAccts.729c4df3.svg";